export default "__VITE_ASSET__46155204__"